import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Option, Response} from '../../model/GeneralModels';
import {MobileInsuranceService} from '../../services/mobile-insurance.service';

@Component({
  selector: 'app-device-type-brand-model-list',
  template: `
    <div class="form-group">
      <div class="row col-12" style="margin-right: 1px !important;">
        <div class="col-4" style="margin-left: 5px !important;">
          <app-select-field
            [Group]="Group"
            [fieldLabel]="'نوع'"
            [options]="typesList"
            [viewList]="viewList"
            [fieldName]="'typeID'"
            (OnChange)="getBrand()"
            [Icon]="true"
          ></app-select-field>
        </div>
        <div class="col-4" style="margin-left: 5px;">
          <app-select-field
            [Group]="Group"
            [fieldLabel]="'برند'"
            [options]="brandsList"
            [viewList]="viewList"
            [fieldName]="'brandID'"
            (OnChange)="resetModel()"
            [Icon]="true"
          ></app-select-field>
        </div>
        <div class="col-4" style="margin-left: 5px;">
          <app-input-field
            [Group]="Group"
            [fieldLabel]="'مىل'"
            [viewList]="viewList"
            [fieldName]="'model'"
            [dataType]="['varchar']"
            [translation]="translation"
            [Icon]="true"
          ></app-input-field>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css',
  ]
})
export class DeviceTypeBrandModelListComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() viewList: any = {};
  @Input() required: boolean;
  @Input() productName: string;
  @Input() translation: any = {};
  typesList: Option[] = [];
  brandsList: Option[] = [];

  constructor(private services: MobileInsuranceService) {
  }

  ngOnInit(): void {
    this.getType();
  }

  getType() {
    this.services.getTypesList().subscribe((response: Response) => {
      if (response.success) {
        this.typesList = [];
        this.brandsList = [];
        response.data.forEach(type => {
          this.typesList[this.typesList.length] = new Option(type.persianLabel, type.id);
        });
      }
    });
  }

  getBrand() {
    this.brandsList = [];
    this.Group.controls.brandID.patchValue('');
    this.resetModel();
    if (this.Group.controls.typeID.valid) {
      this.services.getBrandsList(this.Group.controls.typeID.value).subscribe((response: Response) => {
        if (response.success) {
          response.data.forEach(brand => {
            this.brandsList[this.brandsList.length] = new Option(brand.persianLabel, brand.id);
          });
        }
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Group && !this.Group.controls.typeID) {
      this.Group.addControl('typeID', new FormControl(''));
    }
    if (changes.Group && !this.Group.controls.brandID) {
      this.Group.addControl('brandID', new FormControl(''));
    }
    if (changes.Group && !this.Group.controls.model) {
      this.Group.addControl('model', new FormControl(''));
    }
    if (this.required) {
      this.Group.controls.typeID.setValidators([Validators.required]);
      this.Group.controls.brandID.setValidators([Validators.required]);
      this.Group.controls.model.setValidators([Validators.required]);
    } else {
      this.Group.controls.typeID.setValidators([]);
      this.Group.controls.brandID.setValidators([]);
      this.Group.controls.model.setValidators([]);
    }
  }

  resetModel() {
    this.Group.controls.model.patchValue('');
  }
}
